/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface MissingInfoSendAttempt
 */
export interface MissingInfoSendAttempt {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    idempotency_key: string;
    /**
     * 
     */
    send_status: MissingInfoSendAttemptSendStatusEnum;
    /**
     * 
     */
    final_message_text: string;
    /**
     * 
     */
    connector_message_id?: string;
    /**
     * 
     */
    sent_at?: Date;
    /**
     * 
     */
    failure_type?: string;
    /**
     * 
     */
    date_created: Date;
}


/**
 * @export
 */
export const MissingInfoSendAttemptSendStatusEnum = {
    Pending: 'pending',
    Sending: 'sending',
    Succeeded: 'succeeded',
    Failed: 'failed',
    Unknown: 'unknown',
} as const;
export type MissingInfoSendAttemptSendStatusEnum = typeof MissingInfoSendAttemptSendStatusEnum[keyof typeof MissingInfoSendAttemptSendStatusEnum];


/**
 * Check if a given object implements the MissingInfoSendAttempt interface.
 */
export function instanceOfMissingInfoSendAttempt(value: object): value is MissingInfoSendAttempt {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('idempotency_key' in value) || value['idempotency_key'] === undefined) return false;
    if (!('send_status' in value) || value['send_status'] === undefined) return false;
    if (!('final_message_text' in value) || value['final_message_text'] === undefined) return false;
    if (!('date_created' in value) || value['date_created'] === undefined) return false;
    return true;
}

export function MissingInfoSendAttemptFromJSON(json: any): MissingInfoSendAttempt {
    return MissingInfoSendAttemptFromJSONTyped(json, false);
}

export function MissingInfoSendAttemptFromJSONTyped(json: any, ignoreDiscriminator: boolean): MissingInfoSendAttempt {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'idempotency_key': json['idempotency_key'],
        'send_status': json['send_status'],
        'final_message_text': json['final_message_text'],
        'connector_message_id': json['connector_message_id'] == null ? undefined : json['connector_message_id'],
        'sent_at': json['sent_at'] == null ? undefined : (parseDateTime(json['sent_at'])),
        'failure_type': json['failure_type'] == null ? undefined : json['failure_type'],
        'date_created': (json['date_created'] == null ? json['date_created'] : parseDateTime(json['date_created'])),
    };
}

export function MissingInfoSendAttemptToJSON(json: any): MissingInfoSendAttempt {
    return MissingInfoSendAttemptToJSONTyped(json, false);
}

export function MissingInfoSendAttemptToJSONTyped(value?: MissingInfoSendAttempt | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'idempotency_key': value['idempotency_key'],
        'send_status': value['send_status'],
        'final_message_text': value['final_message_text'],
        'connector_message_id': value['connector_message_id'],
        'sent_at': value['sent_at'] == null ? value['sent_at'] : serializeDateTime(value['sent_at']),
        'failure_type': value['failure_type'],
        'date_created': value['date_created'] == null ? value['date_created'] : serializeDateTime(value['date_created']),
    };
}

